/* rr-pdp.js: product page behaviour for spec v2.17 6F (28 Sept 2026).
   Reference: product-page-and-homepage-mockup.html (Product page tab) and
   sticky-bar-and-footer-options.html (sticky option A, Desktop bar).

   1. Copy button on the part number (label "Copied" for 1.5s).
   2. Detail sections open and close (snippets/rr-product-details.liquid).
      Desktop starts with Description and Features open, phones start closed;
      the CSS does the default, this only records the shopper's choice.
   3. "CAD" after the price in small type (price-ui re-renders on variant
      change, so a MutationObserver keeps it wrapped).
   4. Dino Dollars: the Smile points block's own text ("Earn 588 Dino Dollars
      when completing this purchase.") becomes the light green note "Earn 588
      Dino Dollars on this order. How it works" with the claw icon; the Smile
      section is hidden but keeps running, so its number stays current.
   5. Phone gallery: dots under the swipe gallery (active dot a green bar).
   6. Sticky Add to cart, option A.
      Phone: a bar pinned to the bottom from page load (price, status and
      date, Add to cart) that slides away while the main Add to cart row is
      on screen, so exactly one Add to cart is ever visible.
      Desktop: a slim bar under the header (thumbnail, title, price, Add to
      cart) once the main Add to cart row has scrolled above the header.
      Both buttons press the main Add to cart, so the availability gate, the
      rev press and the ✓ ADDED flip all behave the same; an unticked box
      scrolls to the panel and shows its error (gv-shipping-eta.liquid).
   Reduced motion: the bars appear and disappear without sliding. */
(function () {
  'use strict';
  var doc = document;
  var win = window;
  if (!doc.body || !/(^|\s)product(\s|$|-)/.test(doc.body.className)) return;

  function q(sel, root) { try { return (root || doc).querySelector(sel); } catch (e) { return null; } }
  function qa(sel, root) { try { return [].slice.call((root || doc).querySelectorAll(sel)); } catch (e) { return []; } }
  function el(tag, cls, text) {
    var n = doc.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function isPhone() { try { return win.matchMedia('(max-width: 798px)').matches; } catch (e) { return false; } }

  /* ---- 1. copy the part number ------------------------------------------ */
  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).catch(function () { return legacy(text); });
    }
    return Promise.resolve(legacy(text));
  }
  function legacy(text) {
    var ta = el('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    doc.body.appendChild(ta);
    ta.select();
    try { doc.execCommand('copy'); } catch (e) { /* the label still confirms */ }
    doc.body.removeChild(ta);
  }
  doc.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-rr-copy]') : null;
    if (!b) return;
    e.preventDefault();
    var label = q('span', b);
    copyText(b.getAttribute('data-rr-copy') || '').then(function () {
      if (!label) return;
      label.textContent = 'Copied';
      b.classList.add('is-copied');
      win.clearTimeout(b._rrT);
      b._rrT = win.setTimeout(function () { label.textContent = 'Copy'; b.classList.remove('is-copied'); }, 1500);
    });
  });

  /* ---- 2. detail sections ------------------------------------------------ */
  function initDetails() {
    qa('.rr-acc').forEach(function (acc) {
      var btn = q('.rr-acc__btn', acc);
      if (!btn) return;
      function isOpen() {
        if (acc.classList.contains('is-open')) return true;
        if (acc.classList.contains('is-closed')) return false;
        return acc.hasAttribute('data-rr-default-open') && !isPhone();
      }
      btn.setAttribute('aria-expanded', isOpen() ? 'true' : 'false');
      btn.addEventListener('click', function () {
        var open = !isOpen();
        acc.classList.toggle('is-open', open);
        acc.classList.toggle('is-closed', !open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---- 3. small CAD ------------------------------------------------------ */
  function smallCurrency(root) {
    qa('.product__information .modal_price .money', root).forEach(function (m) {
      if (q('.rr-cur', m)) return;
      var t = m.textContent;
      var mm = t.match(/^(.*?)\s*(CAD|USD)\s*$/);
      if (!mm) return;
      m.textContent = mm[1] + ' ';
      m.appendChild(el('small', 'rr-cur', mm[2]));
    });
  }
  function watchPrice() {
    var box = q('.product__information .modal_price');
    if (!box) return;
    smallCurrency();
    if (!win.MutationObserver) return;
    var busy = false;
    new MutationObserver(function () {
      if (busy) return;
      busy = true;
      smallCurrency();
      busy = false;
      syncBars();
    }).observe(box, { childList: true, subtree: true, characterData: true });
  }

  /* ---- 4. Dino Dollars note ---------------------------------------------- */
  var CLAW_URL = (function () {
    var s = q('script[src*="rr-pdp.js"]');
    return s ? s.src.replace(/rr-pdp\.js.*$/, 'rr-claw-icon.svg') : '';
  })();
  function dinoNote() {
    var host = q('[id*="smile_points_on_product_page"]');
    if (!host) return;
    var src = q('p', host) || host;
    var m = (src.textContent || '').match(/earn\s+([\d,]+)\s+dino dollars/i);
    var note = q('.rr-dd', host.parentNode);
    if (!m) {
      if (note) note.hidden = true;
      return;
    }
    host.classList.add('rr-dd-src');
    if (!note) {
      note = el('div', 'rr-dd');
      var img = el('img', 'rr-dd__icon');
      img.alt = '';
      img.width = 24;
      img.height = 24;
      img.decoding = 'async';
      if (CLAW_URL) img.src = CLAW_URL;
      var text = el('span', 'rr-dd__text');
      note.appendChild(img);
      note.appendChild(text);
      host.parentNode.insertBefore(note, host);
    }
    note.hidden = false;
    var t = q('.rr-dd__text', note);
    t.textContent = 'Earn ';
    /* Smile's figure is CAD-based on both stores, and that is what an order
       earns (owner, 1 Oct 2026), so .com shows it too; the cart converts its
       USD subtotal the same way (cart__main.liquid, rr-cart.js) */
    t.appendChild(el('b', null, m[1] + ' Dino Dollars'));
    t.appendChild(doc.createTextNode(' on this order'));
    /* clearance items (1 Oct 2026): Smile's "Purchase a Clearance Item" bonus, filled by rr-smile.js */
    if (win.rrClearanceItem) {
      var bonus = el('span');
      bonus.setAttribute('data-rr-bonus', 'clearance');
      bonus.setAttribute('data-pre', ', plus ');
      bonus.setAttribute('data-b', '{n} bonus Dino Dollars');
      bonus.setAttribute('data-post', ' for a clearance item');
      bonus.hidden = true;
      t.appendChild(bonus);
    }
    t.appendChild(doc.createTextNode('. '));
    var a = el('a', null, 'How it works');
    a.href = '/pages/rewards';
    t.appendChild(a);
  }
  function watchDino() {
    dinoNote();
    var host = q('[id*="smile_points_on_product_page"]');
    if (!host || !win.MutationObserver) return;
    new MutationObserver(function () { dinoNote(); }).observe(host, { childList: true, subtree: true, characterData: true });
  }

  /* ---- 5. phone gallery dots --------------------------------------------- */
  function initDots() {
    var main = q('.product-gallery__main');
    var $ = win.jQuery;
    if (!main || !$) return;
    var slides = qa('.product-gallery__image', main);
    if (slides.length < 2) return;
    doc.documentElement.classList.add('rr-gallery-multi');
    var dots = el('div', 'rr-gdots');
    dots.setAttribute('aria-hidden', 'true');
    slides.forEach(function (s, i) { var d = el('i'); if (i === 0) d.className = 'is-on'; dots.appendChild(d); });
    main.parentNode.insertBefore(dots, main.nextSibling);
    var thumbs = qa('.product-gallery__thumbnail');
    function mark(i) {
      qa('i', dots).forEach(function (d, k) { d.className = k === i ? 'is-on' : ''; });
      // selected thumbnail gets the 2px Raptor Green border (6F.2)
      thumbs.forEach(function (th, k) { th.classList.toggle('rr-thumb-on', k === i); });
    }
    mark(0);
    $(main).on('change.flickity select.flickity', function () {
      var f = $(main).data('flickity');
      if (f) mark(f.selectedIndex);
    });
  }

  /* ---- 6. sticky Add to cart --------------------------------------------- */
  var mainBtn = null;
  var mainRow = null;
  var mbar = null;
  var dbar = null;
  var mainVisible = true;

  function priceText() {
    var m = q('.product__information .modal_price .money');
    if (!m) return '';
    return (m.firstChild && m.firstChild.nodeType === 3 ? m.firstChild.nodeValue : m.textContent).trim();
  }
  function statusText() {
    var box = q('.shipping-eta-box');
    return box && box.rrEta && box.rrEta.shortLabel ? box.rrEta.shortLabel : '';
  }
  function makeButton(cls) {
    var b = el('button', 'button action_button button--add-to-cart rr-sbar__btn ' + (cls || ''));
    b.type = 'button';
    b.appendChild(el('span', 'text', 'Add to cart'));
    b.addEventListener('click', function (e) {
      e.preventDefault();
      if (!mainBtn) return;
      stickyPress = b;
      win.clearTimeout(stickyTimer);
      stickyTimer = win.setTimeout(function () { stickyPress = null; }, 4000);
      mainBtn.click();
    });
    return b;
  }
  var stickyPress = null;
  var stickyTimer = null;

  function buildBars() {
    mainBtn = q('form.shopify-product-form .button--add-to-cart, form[action*="/cart/add"] button[name="add"]');
    if (!mainBtn) return;
    mainRow = mainBtn.closest('.purchase-details') || mainBtn;

    // phone bar
    mbar = el('div', 'rr-sbar');
    mbar.setAttribute('role', 'region');
    mbar.setAttribute('aria-label', 'Add to cart');
    var info = el('div', 'rr-sbar__info');
    info.appendChild(el('span', 'rr-sbar__price'));
    info.appendChild(el('span', 'rr-sbar__status'));
    mbar.appendChild(info);
    mbar.appendChild(makeButton());
    doc.body.appendChild(mbar);

    // desktop bar
    dbar = el('div', 'rr-dbar');
    dbar.setAttribute('role', 'region');
    dbar.setAttribute('aria-label', 'Add to cart');
    var inner = el('div', 'rr-dbar__in');
    var thumbSrc = '';
    var img0 = q('.product-gallery__main img');
    if (img0) thumbSrc = img0.getAttribute('data-src') || img0.currentSrc || img0.src || '';
    var th = el('img', 'rr-dbar__img');
    th.alt = '';
    th.width = 44;
    th.height = 44;
    th.loading = 'lazy';
    if (thumbSrc && !/^data:/.test(thumbSrc)) th.src = thumbSrc.replace(/_\d+x(\d+)?(\.|@)/, '_120x$2');
    inner.appendChild(th);
    var t = q('.product__information .product-title');
    inner.appendChild(el('span', 'rr-dbar__title', t ? t.textContent.trim() : doc.title));
    inner.appendChild(el('span', 'rr-dbar__price'));
    inner.appendChild(makeButton());
    dbar.appendChild(inner);
    doc.body.appendChild(dbar);

    syncBars();
    if (win.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { mainVisible = en.isIntersecting; });
        place();
      }, { threshold: 0 }).observe(mainRow);
    }
    win.addEventListener('scroll', onScroll, { passive: true });
    win.addEventListener('resize', onScroll, { passive: true });
    doc.addEventListener('rr:eta', syncBars);
    doc.addEventListener('rr:compact', onScroll);
    doc.addEventListener('rr:compact-settled', onScroll);   /* the compact row has landed */
    place();
  }

  function syncBars() {
    if (!mbar) return;
    var p = priceText();
    q('.rr-sbar__price', mbar).textContent = p;
    q('.rr-sbar__status', mbar).textContent = statusText();
    q('.rr-dbar__price', dbar).textContent = p;
    var off = mainBtn && mainBtn.disabled;
    qa('.rr-sbar__btn').forEach(function (b) { b.disabled = !!off; });
  }

  var queued = false;
  function onScroll() {
    if (queued) return;
    queued = true;
    (win.requestAnimationFrame || win.setTimeout)(function () { queued = false; place(); });
  }
  /* 29 Sept (header fold 6n): the full header scrolls away in the page
     flow now, so the bar hangs from whichever is lower, the header or the
     announcement bar */
  function headerBottom() {
    var hdr = q('#header');
    var ann = q('.announcement-bar');
    var b = hdr ? hdr.getBoundingClientRect().bottom : 0;
    var a = ann ? ann.getBoundingClientRect().bottom : 0;
    return Math.max(0, Math.round(Math.max(a, b)));
  }
  var lastTop = '';
  function place() {
    if (!mbar || !mainRow) return;
    var phone = isPhone();
    // phone: on from load, steps aside while the main row is on screen
    var showM = phone && !mainVisible;
    mbar.classList.toggle('is-on', showM);
    doc.documentElement.classList.toggle('rr-sbar-on', showM);
    // desktop: once the main row is above the header, back when it returns
    var hb = headerBottom();
    var r = mainRow.getBoundingClientRect();
    var showD = !phone && r.bottom < hb;
    if (lastTop !== hb + 'px') { lastTop = hb + 'px'; dbar.style.top = lastTop; }
    dbar.classList.toggle('is-on', showD);
  }

  // the ✓ ADDED flip on the sticky button the shopper actually pressed (a
  // blocked press never reaches gv:cart:added and times out after 4s)
  doc.addEventListener('gv:cart:added', function (e) {
    var b = stickyPress;
    stickyPress = null;
    if (!b || !e || !e.detail || e.detail.echo || e.detail.button === b) return;
    var bar = b.closest('.rr-sbar, .rr-dbar');
    if (!bar || !bar.classList.contains('is-on')) return;
    try { doc.dispatchEvent(new CustomEvent('gv:cart:added', { detail: { button: b, echo: true } })); } catch (err) { /* flip is a nicety */ }
  });

  // v2.18 6L E2: choose the variant first, then confirm. The options sit
  // inside the product form, after the "Before you order" panel; the panel
  // block moves to just after them (still inside the form, so its checkbox
  // and line item property keep working). Products without options are
  // left as they are.
  function optionsFirst() {
    var info = doc.querySelector('.product__information');
    if (!info) return;
    /* Flex v7 (29 Sept 2026): the picker is kit-variant-picker; the v6
       variant-selection stays as a fallback */
    var vs = info.querySelector('form[action*="/cart/add"] kit-variant-picker, form[action*="/cart/add"] variant-selection, form[action*="/cart/add"] .variant-selection');
    var eta = info.querySelector('.product-block--shipping-eta');
    if (!vs || !eta || eta.contains(vs)) return;
    var visible = vs.querySelector('select, input[type="radio"], button');
    if (!visible || vs.getBoundingClientRect().height < 4) return;
    /* the Rubicon Rail cutout is part of choosing the part, so it goes with
       the options, before the panel (29 Sept audit, 6L E2) */
    var cut = info.querySelector('form[action*="/cart/add"] .gv-product-option');
    var last = vs;
    if (cut && cut !== vs && !cut.contains(vs)) {
      vs.parentNode.insertBefore(cut, vs.nextSibling);
      last = cut;
    }
    if (last.nextSibling === eta) return;
    last.parentNode.insertBefore(eta, last.nextSibling);
    eta.classList.add('rr-eta-moved');
  }

  /* the cutout's "required" error in the brand style (Deep Red outline and a
     message, like the availability checkbox), not the browser's bubble */
  function cutoutError() {
    var sel = doc.querySelector('.product__information [data-gv-product-option]');
    if (!sel) return;
    var wrap = sel.closest('.gv-product-option');
    var msg = el('p', 'rr-opt-error', 'Choose a Rubicon Rail Front Cutout option.');
    msg.id = 'rr-opt-error-' + (sel.id || 'cutout');
    msg.hidden = true;
    msg.setAttribute('role', 'alert');
    wrap.appendChild(msg);
    sel.addEventListener('invalid', function (e) {
      e.preventDefault();
      wrap.classList.add('is-error');
      msg.hidden = false;
      sel.setAttribute('aria-invalid', 'true');
      sel.setAttribute('aria-describedby', msg.id);
      try { sel.focus({ preventScroll: true }); wrap.scrollIntoView({ block: 'center', behavior: ((window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'auto' : 'smooth') }); } catch (err) { /* nicety */ }
    });
    sel.addEventListener('change', function () {
      if (!sel.value) return;
      wrap.classList.remove('is-error');
      msg.hidden = true;
      sel.removeAttribute('aria-invalid');
    });
  }

  /* each option dropdown is named by its option (kit's select sits beside
     its legend without a label); kit re-renders the picker on every change */
  function labelOptions() {
    qa('kit-variant-picker select.kit-select__native').forEach(function (s) {
      var n = s.getAttribute('data-option-name');
      if (n && !s.getAttribute('aria-label')) s.setAttribute('aria-label', n);
    });
  }

  // Part # follows the selected variant's SKU (owner 29 Sept 2026: the SKU as
  // stored, supplier prefix included); variants without a SKU keep the MPN
  // the page rendered
  function partFollowsVariant() {
    var pn = doc.querySelector('.product__information [data-rr-mpn]');
    var btn = doc.querySelector('.product__information .rr-copy[data-rr-copy]');
    if (!pn) return;
    var fallback = pn.textContent;
    var set = function (v) {
      var sku = v && v.sku ? String(v.sku).trim() : '';
      var val = sku || fallback;
      pn.textContent = val;
      if (btn) {
        btn.setAttribute('data-rr-copy', val);
        btn.setAttribute('aria-label', 'Copy part number ' + val);
      }
    };
    /* Flex v7 dispatches variant-change from the product form (bubbling,
       kit-variant-picker-bridge.js); v6 dispatched it on variant-selection.
       One listener on the product column hears both. */
    var info = doc.querySelector('.product__information');
    if (info) info.addEventListener('variant-change', function (e) { set(e && e.detail ? e.detail.variant : null); });
  }

  /* 3 Oct 2026 (RokBlokz mud flaps showed "Red - Sold Out" on a combination
     that doesn't exist): the picker snippets hide option values with no
     variant for the options before them. If a change leaves a later option on
     such a value (data-rr-missing), move it to the first value that exists,
     in stock first, so the shopper never lands on "Unavailable". The change
     event runs the picker's own refresh. */
  function fixMissing(picker) {
    if (!picker || !picker.querySelector) return;
    var opt = picker.querySelector('select option[data-rr-missing]');
    if (opt && opt.selected) {
      var s = opt.parentNode.closest ? opt.closest('select') : opt.parentNode;
      var real = [].filter.call(s.options, function (o) { return o.value && !o.hasAttribute('data-rr-missing'); });
      var pick = real.filter(function (o) { return !o.disabled && !o.hasAttribute('data-rr-oos'); })[0] || real.filter(function (o) { return !o.disabled; })[0];
      if (pick) { s.value = pick.value; s.dispatchEvent(new Event('change', { bubbles: true })); }
      return;
    }
    var r = picker.querySelector('input[type="radio"][data-rr-missing]:checked');
    if (r) {
      var fs = r.closest('fieldset') || picker;
      var cands = [].filter.call(fs.querySelectorAll('input[type="radio"]'), function (i) { return !i.hasAttribute('data-rr-missing') && !i.disabled; });
      var p = cands.filter(function (i) { return !i.hasAttribute('data-rr-oos'); })[0] || cands[0];
      if (p) { p.checked = true; p.dispatchEvent(new Event('change', { bubbles: true })); }
    }
  }

  /* 3 Oct 2026: the breadcrumb's subcategory crumb has no href (bots followed
     it into /a/search and paged through every result); go to the search here. */
  function crumbSearch() {
    function go(el) {
      var q = el.getAttribute('data-rr-crumb-q');
      if (!q) return;
      var base = (win.PXUTheme && win.PXUTheme.routes && win.PXUTheme.routes.search_url) || '/search';
      win.location.href = base + '?q=' + encodeURIComponent(q) + '&type=product';
    }
    doc.addEventListener('click', function (e) {
      var el = e.target && e.target.closest && e.target.closest('[data-rr-crumb-q]');
      if (el) { e.preventDefault(); go(el); }
    });
    doc.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var el = e.target && e.target.closest && e.target.closest('[data-rr-crumb-q]');
      if (el) { e.preventDefault(); go(el); }
    });
  }

  function boot() {
    crumbSearch();
    optionsFirst();
    cutoutError();
    labelOptions();
    doc.addEventListener('variant-change', function () { setTimeout(labelOptions, 0); });
    doc.addEventListener('kit:variant-picker:after-change', function (e) {
      setTimeout(labelOptions, 0);
      var picker = (e && e.detail && e.detail.picker) || (e && e.target);
      setTimeout(function () { fixMissing(picker); }, 0);
    });
    qa('kit-variant-picker').forEach(function (p) { fixMissing(p); });
    partFollowsVariant();
    initDetails();
    watchPrice();
    watchDino();
    initDots();
    buildBars();
    win.addEventListener('load', function () { dinoNote(); smallCurrency(); syncBars(); });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
